<template>
	<div>
		<div class="breathe-sm is-hidden-mobile"><strong>Refine By</strong></div>

		<!--<div class=" breathe-sm">
			<div><strong>Expected Compensation</strong> (Seeking)</div>
			<div v-for="result in facets" :key="result.Id">
				<a >{{result.Name}}</a>
			</div>
		</div>-->

		<div class="breathe-sm" v-if="countryLimits && countryLimits.length">
			<div><strong>Country</strong> (Current)</div>
			<div v-for="result in countryLimits" :key="result.id">
				<a @click="addCountryAndSearch(result.Id)">{{result.Name}}</a> ({{result.Count}})
			</div>
			<a @click="countryHide = !countryHide">Show more</a>
		</div>

		<div class="breathe-sm" v-if="funtionLimits && funtionLimits.length">
			<div><strong>Function</strong> (Current)</div>
			<div v-for="result in funtionLimits" :key="result.Id">
				<a @click="addFunctionAndSearch(result.Id)">{{result.Name}}</a> ({{result.Count}})
			</div><a @click="functionLimit = null">Show more</a>
		</div>

		<div class="breathe-sm" v-if="false">
			<div><strong>Gender</strong></div>
			<div v-for="result in limit" :key="result.Id">
				<a>{{result.Name}}</a> ({{result.Count}})
			</div>
		</div>

		<div class="breathe-sm" v-if="industryLimits && industryLimits.length">
			<div><strong>Industry</strong> (Current)</div>
			<div v-for="result in industryLimits" :key="result.Id">
				<a @click="addIndustryAndSearch(result.Id)">{{result.Name}}</a> ({{result.Count}})
			</div><a @click="industryHide = !industryHide">Show more</a>
		</div>

		<div class="breathe-sm" v-if="languageLimits && languageLimits.length">
			<div><strong>Language</strong></div>
			<div v-for="result in languageLimits" :key="result.Id">
				<a @click="addLanguageAndSearch(result.Id)">{{result.Name}}</a> ({{result.Count}})
			</div><a @click="languageLimit = null">Show more</a>
		</div>

		<div class="breathe-sm" v-if="regionLimits && regionLimits.length">
			<div><strong>Region</strong></div>
			<div v-for="result in regionLimits" :key="result.Id">
				<a @click="addStateAndSearch(result.Id)">{{result.Name}}</a> ({{result.Count}})
			</div><a @click="regionLimit = null">Show more</a>
		</div>

		<div class="breathe-sm" v-if="stateLimits && stateLimits.length">
			<div><strong>State</strong> (Current)</div>
			<div v-for="result in stateLimits" :key="result.Id">
				<a @click="addStateAndSearch(result.Id)">{{result.Name}}</a> ({{result.Count}})
			</div><a @click="stateLimit = null">Show more</a>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			Facets: Object
		},
		data() {
			return {
				facets: [],
				idPath: "",
				imagePath: "",
				facetResults: [],
				compensation: [],
				countryHide: true,
				functionHide: true,
				languageHide: true,
				regionHide: true,
				stateHide: true,
				industryHide: true,
				facetModal: false,
				limit: 5,
				Industries: [],
				JobFunctions: {},
				Regions: {},
				Countries: {},
				States: {},
				CompensationRanges: {},
				Languages: {},
				PersonalTitles: {}

			}
		},
		created() {
			this.getQuery();

			this.facets = this.Facets;
			this.$http.get('api/filter/all')
				.then((response) => {
					this.Industries = response.data.Industries;
					this.JobFunctions = response.data.JobFunctions;
					this.Regions = response.data.Regions;
					this.Countries = response.data.Countries;
					this.States = response.data.Countries;
					this.CompensationRanges = response.data.CompensationRanges;
					this.Languages = response.data.Languages;
					this.PersonalTitles = response.data.PersonalTitles;
				});
		},
		//beforeDestroy() {
		//	this.$store.dispatch("setQuery", this.query);
		//},
		computed: {
			countryLimits() {
				if (this.facets && this.facets.Countries)
					return this.countryHide ? this.facets.Countries.slice(0, this.limit) : this.facets.Countries;
				return null;
			},
			funtionLimits() {
				if (this.facets && this.facets.JobFunctions)
					return this.functionHide ? this.facets.JobFunctions.slice(0, this.limit) : this.facets.JobFunctions;
				return null;
			},
			languageLimits() {
				if (this.facets && this.facets.Languages)
					return this.languageHide ? this.facets.Languages.slice(0, this.limit) : this.facets.UserLanguages;
				return null;
			},
			regionLimits() {
				if (this.facets && this.facets.Regions)
					return this.regionHide ? this.facets.Regions.slice(0, this.limit) : this.facets.Regions;
				return null;
			},
			stateLimits() {
				if (this.facets && this.facets.States)
					return this.stateHide ? this.facets.States.slice(0, this.limit) : this.facets.States;
				return null;
			},
			industryLimits() {
				if (this.facets && this.facets.Industries)
					return this.industryHide ? this.facets.Industries.slice(0, this.limit) : this.facets.Industries;
				return null;
			}
		},
		methods: {
			addCountryAndSearch: async function (Id) {
				this.query.Country = [];
				this.query.Country.push(Id);
				this.resetSearch();
			},
			addFunctionAndSearch: async function (Id) {
				this.query.Function = [];
				this.query.Function.push(Id);
				this.resetSearch();
			},
			addIndustryAndSearch: async function (Id) {
				this.query.Industry = [];
				this.query.Industry.push(Id);
				this.resetSearch();
			},
			addLanguageAndSearch: async function (Id) {
				this.query.Language = [];
				this.query.Language.push(Id);
				this.resetSearch();
			},
			addStateAndSearch: async function (Id) {
				this.query.State = [];
				this.query.State.push(Id);
				this.resetSearch();
			},
			getQuery: function () {
				return this.query = this.$store.getters.query;
			},
			resetSearch() {
				this.$store.dispatch("setQuery", this.query);
				this.$parent.searchResults = [];
				this.$parent.page = 0;
				this.$parent.searching = true;
				this.$parent.search();
			}


		}
	}
</script>

<style scoped>
</style>
